import { normalizeCapabilities } from '@rsos/capstone';
import { JURISDICTION_VIEW } from '@rsos/capstone/src/constants/capabilities';
import { selectUserOrgByApp } from '@rsos/sinatra';
import determineDataPath from '@rsos/utils/determineDataPath';
import { getPSAPInfo, forcedLogOut } from './../actions';
import { isAdminApproved } from './isAdminApproved';

export const checkAccessLevel = currentRole => {
  const application = currentRole.application;
  let permissions;
  if (application === 'capstone' || application === 'central_station') {
    permissions = {
      MANAGE_USERS: currentRole.permissions.includes('MANAGE_USERS'),
      RIDE_SHARING: currentRole.permissions.includes('RIDE_SHARING'),
      PROFILE_INFO: currentRole.permissions.includes('PROFILE_INFO'),
    };
  }
  return permissions;
};

const handleRedirect = async (dispatch, getState) => {
  const sinatra = getState().sinatra;
  const isICSP = sinatra.irp.isICSP;
  const application = sinatra.user.currentRole.application;
  const MANAGE_USERS = checkAccessLevel(sinatra.user.currentRole).MANAGE_USERS;
  const isLoggedIn = sinatra.user.isLoggedIn;

  if (!isLoggedIn) {
    window.location.assign('/');
    return;
  }
  if (isICSP && application === 'central_station') {
    window.location.assign('/incident-central-station');
    // ICSP central-station users have a dedicated destination. Treat that
    // redirect as terminal so the normal CSP/RSP PSAP lookup path does not run
    // and issue a second navigation after the browser has already started
    // leaving the login app.
    return;
  }
  try {
    let { currentRole = {} } = sinatra.user;
    const org = selectUserOrgByApp(sinatra, currentRole.application);
    const { irp_access_token } = sinatra.irp;
    const psap = await dispatch(getPSAPInfo(org.name));
    if (typeof psap !== 'object' || !psap.psapInfo) {
      throw new Error('Missing PSAP Info');
    }
    if (
      application !== 'central_station' &&
      !isAdminApproved(psap.psapInfo.jurisdictions) &&
      MANAGE_USERS
    ) {
      window.location.assign('/admin/psap/#boundary-upload');
    }
    const { active_capabilities = {} } = psap.psapInfo;
    const normalizedActiveCapabilities =
      normalizeCapabilities(active_capabilities);
    const isJVenabled = !!normalizedActiveCapabilities[JURISDICTION_VIEW];
    return window.location.assign(
      determineDataPath(
        currentRole.application,
        isJVenabled,
        irp_access_token,
        isLoggedIn,
      ),
    );
  } catch (e) {
    if (e.status === 401 || e.status == 403) {
      dispatch(forcedLogOut);
      return;
    }
    throw e;
  }
};
export default handleRedirect;
